import classNames from 'classnames';

import { Wysiwyg as SVG } from '@jsmdg/yoshi';
import { AttributeType } from '../../../shared/enums';
import { type ProductAttribute } from '../../../shared/types';
import { Divider } from '../Divider/Divider';
import styles from './AttributesContainer.module.scss';

type AttributesContainerProps = {
    readonly attributes?: ProductAttribute[];
};

function getAttributeDisplayValue(attribute: ProductAttribute): string | null {
    if (attribute.type === AttributeType.QUANTITY) {
        return `${attribute.value as number} ${attribute.unit as string} ${attribute.title}`;
    }

    if (attribute.type === AttributeType.NUMERIC) {
        return `${attribute.value as number} ${attribute.title}`;
    }

    if (attribute.type === AttributeType.STRING || attribute.type === AttributeType.HTML) {
        return attribute.value as string;
    }

    if (attribute.type === AttributeType.BOOLEAN) {
        return attribute.title;
    }

    return null;
}

function isProductAttributes(
    attributes: ProductAttribute[] | undefined,
): attributes is ProductAttribute[] {
    return Boolean(attributes?.length);
}

const AttributesContainer = ({ attributes }: AttributesContainerProps): JSX.Element => {
    const visibleAttributes = attributes?.filter(
        attribute => !attribute.isHidden && getAttributeDisplayValue(attribute),
    );

    return (
        <>
            {isProductAttributes(visibleAttributes) && (
                <div className={classNames(styles.container, 'pb-sm-3x')}>
                    <Divider className="d-block d-sm-none" />
                    <div className="pt-2x pt-sm-0 pb-3x pb-sm-0 d-flex flex-wrap">
                        {visibleAttributes.map(attribute => (
                            <div
                                className="d-flex mr-4x pt-1x"
                                key={getAttributeDisplayValue(attribute)}
                            >
                                {/* eslint-disable-next-line react/jsx-pascal-case */}
                                <SVG
                                    content={attribute.icon}
                                    key={attribute.title}
                                    className={classNames('mr-1x w-auto', styles.themedIcon)}
                                />
                                <span>{getAttributeDisplayValue(attribute)}</span>
                            </div>
                        ))}
                    </div>
                    <Divider className="d-block d-sm-none" />
                </div>
            )}
        </>
    );
};

export { AttributesContainer };
